import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';

// CONSTANTS
import { LOCATIONS_FREE_TV_LANDING_PAGE } from '@/constants/locations';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';
import { externalLink } from '@/utility/analytics';

// COMPONENTS

const heroImg = getS3ImageUrl('/free-tv/hero.png');
const heroImgX2 = getS3ImageUrl('/free-tv/hero-x2.png');

const Hero = () => {
  const [t] = useTranslation();

  const handleExternalLink = href => {
    const properties = {
      location: LOCATIONS_FREE_TV_LANDING_PAGE,
      other: 'hero external link',
      href,
    };

    externalLink(properties);
  };

  return (
    <div className="hero section">
      <div className="page-content">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={7} md={6}>
            <Typography className="section__title" component="h1" variant="h2">
              <Trans
                i18nKey="freeTv.title"
                components={{
                  span: <span className="text-color--primary" />,
                }}
              />
            </Typography>
            <Typography className="hero__subtitle text-regular m-b-30" variant="subtitle2">
              {t('freeTv.subtitle')}
            </Typography>

            <Button
              href="https://freetv.mybundle.com"
              target="_blank"
              color="primary"
              variant="contained"
              onClick={() => handleExternalLink('https://freetv.mybundle.com')}
            >
              {t('buttons.watchLive')}
            </Button>
          </Grid>
          <Grid item xs={12} sm={5} md={6}>
            <img className="hero__img" srcSet={`${heroImgX2} 2x`} src={heroImg} alt="smart-tv" />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default React.memo(Hero);
